var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2222 12.4444C22.2222 0 27.7938 0 34.6667 0C35.1576 0 35.5556 0.397969 35.5556 0.888889V4C35.5556 4.55228 36.0033 5 36.5556 5H39C39.5523 5 40 5.44772 40 6V22.1264C40 29.2363 34.2363 35 27.1264 35C26.8725 35 26.6667 34.7942 26.6667 34.5402V31C26.6667 30.4477 26.219 30 25.6667 30H23.2222C22.6699 30 22.2222 29.5523 22.2222 29V12.4444Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7778 12.4444C17.7778 0 12.2062 0 5.33333 0C4.84241 0 4.44444 0.397969 4.44444 0.888889V4C4.44444 4.55228 3.99673 5 3.44444 5H1C0.447716 5 0 5.44772 0 6V22.1264C0 29.2363 5.76369 35 12.8736 35C13.1275 35 13.3333 34.7942 13.3333 34.5402V31C13.3333 30.4477 13.781 30 14.3333 30H16.7778C17.3301 30 17.7778 29.5523 17.7778 29V12.4444Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.601390a3dbe03083dc4317560051a4ea.svg";
export { ForwardRef as ReactComponent };